<template>
  <div class='gallery'>
    <carousel ref="big"
              v-on:pageChange="syncCarousels"
              :minSwipeDistance=24
              :perPage=1 :paginationEnabled="false"
              :navigationEnabled="true"
              paginationActiveColor="#f4c5c8">
        <slide v-for="(image, index) in images" v-bind:key="image + index">
          <div class="img"
               :style="{backgroundImage: 'url(\'' + image.url + '\')'}"></div>
          <p>
            <ul v-if="image.name"><li>{{image.name}}</li></ul>
          </p>
        </slide>
    </carousel>
    <carousel :minSwipeDistance=24 ref="mini" class="mini"
              :scrollPerPage=true :perPage=5
              :navigationEnabled="true" paginationActiveColor="#f4c5c8">
      <slide v-for="(image, index) in images" v-bind:key="image + index">
        <div class="img"
             v-on:click='handleMiniClick'
             :style="{backgroundImage: 'url(\'' + image.url + '\')'}"></div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  props: ['images'],
  name: 'ImageGallery',
  components: {Carousel, Slide},
  methods: {
    syncCarousels: function (index) {
      this.$refs.big.currentPage = index
      let mini = this.$refs.mini
      mini.currentPage = Math.floor(index / mini.perPage)
      mini.$children[this.highlightedIndex].$el.classList.remove('highlighted')
      mini.$children[index].$el.classList.add('highlighted')
      this.highlightedIndex = index
    },
    handleMiniClick: function (e) {
      let clickedSlide = e.target.parentElement
      let slides = this.$refs.mini.$el.children[0].children[0].children
      let index = Array.prototype.indexOf.call(slides, clickedSlide)
      this.syncCarousels(index)
    }
  },
  data: () => {
    return { highlightedIndex: 0 }
  },
  mounted: function () {
    this.syncCarousels(0)
  }
}
</script>
<style scoped>
.gallery {
  margin-top: 2em;
}
.mini .VueCarousel-slide div.img {
  height: 100px;
  width: 100px;
  margin: 10px;
  cursor: pointer;
}

.mini .VueCarousel-slide ul {
  display: none;
}
.mini .VueCarousel-slide.highlighted div.img {
  border: 4px dashed #f4c6c9;
  margin: 6px;
}

.VueCarousel-slide div.img {
  display: inline-block;
  height: 500px;
  width: 500px;
  background-size: contain;
  background-repeat: no-repeat;
  background-color: #faeced;
  background-position: center;
  margin: 0 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageGallery.vue